export enum EVENT_CHANNELS {
  MIXPANEL = "mixpanel",
  GA = "ga",
}

export enum EVENT_TYPES {
  WEB_SUPPORT_HELP_CENTRE_TOPIC = "web_support_help_centre_topic",
  WEB_SUPPORT_HELP_CENTRE_ARTICLE = "web_support_help_centre_article",
  WEB_SUPPORT_HELP_SEARCH_BAR_INPUT = "web_support_help_centre_search_bar_input",
  WEB_SUPPORT_HELP_CENTRE_RECENT_ACTIVITIES_VIEW_ALL = "web_support_help_centre_recent_activities_view_all",
  WEB_SUPPORT_HELP_CENTRE_RECENT_ACTIVITIES = "web_support_help_centre_recent_activities",
  WEB_SUPPORT_HELP_CENTRE_LOGIN_SUCCESS = "web_support_help_centre_login_success",
  WEB_SUPPORT_HELP_CENTRE_LOGIN_FAILED = "web_support_help_centre_login_failed",
  WEB_SUPPORT_HELP_CENTRE_CONTACT_LIVE_CHAT = "web_support_help_centre_contact_live_chat",
  WEB_SUPPORT_HELP_CENTRE_CONTACT_EMAIL = "web_support_help_centre_contact_email",
  WEB_SUPPORT_HELP_CENTRE_ACCESS_CHAT_HISTORY = "web_support_help_centre_access_chat_history",
  WEB_SUPPORT_HELP_CENTRE_SUBMIT_FEEDBACK = "web_support_help_centre_submit_feedback",
  WEB_SUPPORT_HELP_CENTRE_SUBMIT_RECEIPT_FORM = "web_support_help_centre_submit_receipt_form",
  WEB_SUPPORT_HELP_CENTRE_CHANGE_MOBILE_NUMBER_FORM_SUBMIT = "web_support_help_centre_change_mobile_number_form_submit",
  WEB_SUPPORT_HELP_CENTRE_REPORT_A_PROBLEM_CHAT = "web_support_help_centre_report_a_problem_chat",
  WEB_SUPPORT_HELP_CENTRE_MESRA_CARD_LINK_FORM_SUBMIT = "web_support_help_centre_mesra_card_link_form_submit",
  WEB_SUPPORT_HELP_CENTRE_EMADANI_FORM_OPEN = "web_support_help_centre_emadani_form_open",
  WEB_SUPPORT_HELP_CENTRE_EMADANI_FORM_SUBMIT = "web_support_help_centre_emadani_form_submit",
  WEB_SUPPORT_HELP_CENTRE_EMADANI_FORM_SUCCESS = "web_support_help_centre_emadani_form_success",
  WEB_SUPPORT_HELP_CENTRE_EMADANI_FORM_FAILED = "web_support_help_centre_emadani_form_failed",

  SUPPORT_INITIATE_CHAT = "support_initiate_chat",
  SUPPORT_CHAT_ATTENDED_BY_AGENT = "support_chat_attended_by_agent",
  SUPPORT_CHAT_CLOSED = "support_chat_closed",
}
